<template>
  <div class="layout">
    <div class="layout_chidT">用户转化数据</div>
    <van-row class="order-card1-content">
      <div v-for="(item, index) in briskUserData" :key="index">
        <van-col :span="item.colCount" style="padding: 20px 0;">
          <p style="margin-bottom: 6px;">{{ item.name }}</p>
          <h1>
            <count-to :decimals="item.countConfig.decimals" :duration="item.countConfig.duration" :end-val="item.countConfig.endVal" :prefix="item.countConfig.prefix" :separator="item.countConfig.separator" :start-val="item.countConfig.startVal" :suffix="item.countConfig.suffix" />
          </h1>
        </van-col>
      </div>
    </van-row>

    <div class="layout_chidT" style="margin-top: 10px;">实时访问数据</div>
    <van-row class="order-card1-content">
      <div v-for="(item, index) in newUserData" :key="index">
        <van-col :span="item.colCount" style="padding: 20px 0;">
          <p style="margin-bottom: 6px;">{{ item.name }}</p>
          <h1>
            <count-to :decimals="item.countConfig.decimals" :duration="item.countConfig.duration" :end-val="item.countConfig.endVal" :prefix="item.countConfig.prefix" :separator="item.countConfig.separator" :start-val="item.countConfig.startVal" :suffix="item.countConfig.suffix" />
          </h1>
        </van-col>
      </div>
    </van-row>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: '',
  props: {
    briskUserData: {
      type: Array,
      default: [],
    },
    newUserData: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
     
    }
  },
}
</script>

<style lang="less" scoped>
.layout {
  padding: 10px 20px;
  &_chidT {
    position: relative;
    margin-bottom: 10px;
    padding-left: 10px;
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    color: #333;
    margin-top: 10px;
  }
  &_chidT::after {
    content: '';
    position: absolute;
    width: 4px;
    height: 18px;
    background-color: #05a64c;
    top: 0;
    left: 0px;
  }
}
.order-card1-content {
  background: #f8f8f8;
  border-radius: 10px;
}
</style>